import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonsCollection, Header } from '@/ui-kit';
import { ArticleForm } from '@/views/knowledgeBase/components/articleForm';
import api from '../../../../api/knowledgeBase.service';
import './style.sass';
import { callNotification } from '@/utils/helpers/notifies';

export const EditArticle = () => {
  const { t } = useTranslation();

  const { push } = useHistory();
  const { subcategoryId, articleId } = useParams();

  const [article, setArticle] = useState(null);

  const fetchArticle = async () => {
    const res = await api.getKnowledgeBaseArticleById(articleId);

    setArticle(res);
  };

  useEffect(() => {
    fetchArticle();
  }, []);

  const form = useForm({
    defaultValues: {
      title: '',
      content: '',
      categoryIds: [],
    },
  });

  useEffect(() => {
    if (article) {
      form.reset({
        title: article.title,
        content: article.content,
        categoryIds: article.categoryIds,
      })
    }
  }, [article]);

  const onClose = useCallback(() => {
    push(`/knowledge-base/subcategory/${subcategoryId}/`)
  }, [subcategoryId]);

  const onSubmit = useCallback(async (values) => {
    try {
      await api.updateKnowledgeBaseArticle(articleId, { files: [], ...values });

      callNotification.success('Article has been updated.');

      onClose();
    } catch (e) {
      callNotification.error('Error with updating article.');
      console.error(e);
    }
  }, [])

  return (
    <>
      <Header hideToggleRightSideBar className="edit-article__header">
        <h1 className="weight--medium title--sm title-page">
          <ButtonsCollection.ButtonIcons
            title={t('Go back to subcategory')}
            renderMobileButton
            className="edit-article__header__head-back"
            onClick={onClose}
          >
            <span className="icon-expand-arrow-left" />
          </ButtonsCollection.ButtonIcons>
          Edit article
        </h1>
      </Header>
      <div className="main-container__content edit-article__container">
        <FormProvider {...form}>
          <ArticleForm
            onAction={onSubmit}
            submitButtonText={t('Edit article')}
          />
        </FormProvider>
      </div>
    </>
  )
}
